import { createSelector } from 'reselect';
import moment from 'moment';
import * as constants from './constants';
/**
 * Direct selector to the domain's state
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
/**
 * Chart mode
 */ export const mode = createSelector(mainSelector, (state)=>state.mode);
/**
 * Chart device mode
 */ export const deviceMode = createSelector(mainSelector, (state)=>state && state.deviceMode);
/**
 * Calculation formula for aggregation
 */ export const calculationFormula = createSelector(mainSelector, (state)=>state.calculationFormula);
/**
 * Time unit for aggregation
 */ export const aggregateBy = createSelector(mainSelector, (state)=>state.aggregateBy);
/**
 * Type of grouping
 */ export const groupBy = createSelector(mainSelector, (state)=>state.groupBy);
/**
 * Import document ids that are loaded on chart
 */ export const fromImports = createSelector(mainSelector, (state)=>state.fromImports);
/**
 * Min and max readings timestamps for selected imports
 */ export const fromImportsRange = createSelector(mainSelector, (state)=>state.fromImportsRange);
/**
 * Selects if trend chart line is enabled
 */ export const isTrendChartLineEnabled = createSelector(mainSelector, (state)=>state.isTrendChartLineEnabled);
/**
 * Selects if CGM goals are visible
 */ export const showCGMGoals = createSelector(mainSelector, (state)=>state.showCGMGoals);
/**
 * Selects if GCL tight range is visible
 */ export const showTightRange = createSelector(mainSelector, (state)=>state.showTightRange);
/**
 * Layout of dashboard widgets
 */ export const dashboardLayout = createSelector(mainSelector, (state)=>state.dashboardLayout);
/**
 * Is results fetching
 */ export const resultsIsInProgress = createSelector(mainSelector, (state)=>state && state.resultsIsInProgress);
//----------------------------------------------------------------------------------------------------------------------
/**
 * Reports state
 */ export const reportsState = createSelector(mainSelector, (state)=>state.reportsState);
/**
 * Reports state MedicalRecord
 */ export const reportsStateMedicalRecord = createSelector(mainSelector, (state)=>state.reportsState && state.reportsState.accountPatientProfile);
/**
 * Reports state PhiSet
 */ export const reportsStatePhiSet = createSelector(mainSelector, (state)=>state.reportsState && state.reportsState.phiSet);
/**
 * Reports state Readings
 */ export const reportsStateReadings = createSelector(mainSelector, (state)=>state.reportsState && state.reportsState.readings);
/**
 * Reports state RelatedData
 */ export const reportsStateRelatedData = createSelector(mainSelector, (state)=>state.reportsState && state.reportsState.relatedData);
/**
 * Reports state TimeSeriesResources
 */ export const reportsStateTimeSeriesResources = createSelector(mainSelector, (state)=>state.reportsState && state.reportsState.timeSeriesResources);
//----------------------------------------------------------------------------------------------------------------------
/**
 * Report types to be rendered on reports page
 */ export const reportTypes = createSelector(mainSelector, (state)=>state.reportTypes);
export const gestationalReportSettingsSelector = createSelector(mainSelector, (state)=>state.gestationalReportSettings);
export const standardsSelector = createSelector(reportsState, (state)=>state.standards);
export const selectedReading = createSelector(mainSelector, (state)=>state.selectedReading);
/**
 * Active patient blood glucose readings
 */ export const readings = createSelector(reportsState, (state)=>state.readings);
export const readingsRangeDate = createSelector(readings, (readingsState)=>(daysEndOffset, daysBeforeEndOffset = 30)=>{
        const lastPossibleMoment = moment.utc().add(-daysEndOffset, 'days').endOf('day').locale('en--account');
        const firstPossibleMoment = lastPossibleMoment.clone().add(-(daysBeforeEndOffset - 1), 'days').startOf('day');
        const firstPossibleTimestamp = firstPossibleMoment.unix();
        const lastPossibleTimestamp = lastPossibleMoment.unix();
        return readingsState.filter((reading)=>reading.timestamp > firstPossibleTimestamp && reading.timestamp < lastPossibleTimestamp);
    });
export const imbPatterns = createSelector([
    (state)=>mainSelector(state).imbPatterns
], (imbPatternsState)=>imbPatternsState);
